import { title } from "assets/jss/material-kit-react.jsx";

const workStyle = {
  section: {
    padding: "22vh 30px",
    bottom: '10vh',
    position: 'relative',
    zIndex: "2",
  },
  title: {
    ...title,
    marginBottom: "50px",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    textAlign: "center",
    color: '#FFFFFF'
  },
  description: {
    color: "#FFFFFF",
    textAlign: "center"
  },
  textCenter: {
    textAlign: "center"
  },
  textArea: {
    marginRight: "15px",
    marginLeft: "15px"
  }
};

export default workStyle;
